import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/23_five_cats/23_five_cats"
 * Contains 1 texture(s)
 */
export class Desktop23FiveCatsAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/23_five_cats/23_five_cats';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '23_five_cats.jpg'
    ] as const;
}
